import { type JSX, useEffect, useState } from 'react';
import type { Process } from '@common/interfaces';
import type { HolterConsultRequestData } from '@common/validation/customControls/cardiology/holter/holterConsultRequestSchemas';
import type { HolterAdviceQuestionContentKeys } from '@common/validation/customControls/cardiology/holter/holterConsultSchemas';
import type { ContentComponentsMap } from '@frontend/formEngine/editForm/editForm.types';
import { CustomControlCode, ProcessActivityStatus, ServiceCode } from '@common/enums';
import { findSingleProcessByServiceCode, getLastProcessActivityByCustomControlCodes } from '@common/utils/processUtil';
import { holterConsultSections } from '@common/validation/customControls/cardiology/holter/holterConsultSchemas';
import { EditForm } from '@frontend/formEngine/editForm/EditForm';
import { usePatientEpisodeCategoryContext } from '@frontend/utils/hooks/usePatientEpisodeCategoryContext';
import { HolterAdviceQuestionReadOnly } from '../customComponents/HolterAdviceQuestionReadOnly';

export function HolterConsultEdit(): JSX.Element {
    const [adviceQuestion, setAdviceQuestion] = useState<string>();

    const { processes } = usePatientEpisodeCategoryContext();
    const process = findSingleProcessByServiceCode(processes, ServiceCode.Holter);

    useEffect(() => {
        if (process) {
            const consutRequestProcessActivity = getAdviceQuestion(process);
            const customControlData = consutRequestProcessActivity?.customControlData as
                | HolterConsultRequestData
                | undefined;

            if (customControlData?.adviceQuestion) {
                setAdviceQuestion(customControlData?.adviceQuestion);
            }
        }
    }, [process]);

    return (
        <EditForm
            contentComponents={getContentComponent(adviceQuestion ?? '')}
            sections={holterConsultSections}
        />
    );
}

export function getContentComponent(text: string): ContentComponentsMap<HolterAdviceQuestionContentKeys> {
    const map: ContentComponentsMap<HolterAdviceQuestionContentKeys> = new Map();
    map.set('advice', <HolterAdviceQuestionReadOnly adviceQuestion={text} />);

    return map;
}

function getAdviceQuestion(process: Process) {
    const latestConsultRequest = getLastProcessActivityByCustomControlCodes(
        process,
        [CustomControlCode.HolterConsultRequest],
        [ProcessActivityStatus.complete]
    );

    if (latestConsultRequest) {
        return latestConsultRequest;
    }

    return undefined;
}
